var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
define(["require", "exports", "hypo_bvo/Drklein/GoogleMapsButton/GoogleMapsButton", "hypo_bvo/Drklein/NichtIhreRegionHint/NichtIhreRegionHint", "hypo_elements/Typescripts/Geolocation/Geolocation", "hypo_elements/Typescripts/GoogleMaps/GoogleMaps", "hypo_elements/Typescripts/Mustache/Mustache", "hypo_elements/Typescripts/UrlParameters/UrlParameters", "hypo_bvo/Drklein/Shared/OfficeService", "jquery"], function (require, exports, GoogleMapsButton, NichtIhreRegionHint, Geolocation, GoogleMaps, HypoportMustache, UrlParameters, OfficeService) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    GoogleMapsButton = __importStar(GoogleMapsButton);
    NichtIhreRegionHint = __importStar(NichtIhreRegionHint);
    Geolocation = __importStar(Geolocation);
    GoogleMaps = __importStar(GoogleMaps);
    HypoportMustache = __importStar(HypoportMustache);
    UrlParameters = __importStar(UrlParameters);
    OfficeService = __importStar(OfficeService);
    $(function () {
        //Load 10 offices at the same time
        var PAGE_SIZE = 10;
        var SEARCH_THROBBER_ID = "#agent_search_throbber";
        var $officeSearch = $(".beratersuche");
        var $officeSearchForm = $officeSearch.find("#beraterSucheFormular");
        var $beratersucheNichtIhreRegion = $officeSearchForm.find(".beratersuche_nichtIhreRegionButton");
        var $beratersucheNichtIhreRegionHint = $officeSearchForm.find(".beratersuche_nichtIhreRegion");
        var searchResultContainer = $officeSearch.find("#beraterSucheResult");
        var $loadMoreButton = $officeSearch.find("#beraterSucheLoadMore");
        var $officeTemplate = $officeSearch.find("#bueroTemplate");
        var localStoragePath = "hypoport.agent-search-storage.search-params";
        //Ids of all office currently displayed
        var displayedOffices;
        var currentLocation;
        var officeQuery;
        var unfilteredOfficeQuery;
        // If there are no more offices that match the search criteria, other offices that do not match the search criteria are also displayed
        var unfilteredLastUsed = true;
        var consideringLastName = true;
        var consideringProductGroups = true;
        var bufferedOffices = [];
        /**
         * Sometimes there are multiple requests running in parallel. If the user re-submits the form, all running requests
         * should be cancelled because otherwise mixups happen.
         * To know which async response is too old, we have a transactionId that is the same for all "currently valid" requests
         * It is incremented whenever we want to stop processing the responses of all current requests
         */
        var currentTransactionId = 1;
        //If Javascript is enabled, hold back the warning message
        $("#agent_search_javascript_warning").hide();
        //Try to load the agents, show a loading animation while this is happening
        $(SEARCH_THROBBER_ID).show();
        //Hide the "Load more" button as long as the first offices have not yet been loaded
        $loadMoreButton.hide();
        /**
         * Clear all search results
         */
        function clearResults() {
            displayedOffices = [];
            searchResultContainer.empty();
            $loadMoreButton.hide();
            consideringLastName = false;
            consideringProductGroups = false;
            bufferedOffices = [];
            currentTransactionId++;
        }
        /**
         * Handle a promise from the office-service with a response from server
         * @param officePage
         */
        function handleOfficeResponse(officePage) {
            function getAgents(sortedAgentWithAmounts) {
                var agents = [];
                for (var i = 0; i < sortedAgentWithAmounts.length; i++) {
                    agents.push(sortedAgentWithAmounts[i][1]);
                }
                return agents;
            }
            function countNumberOfMatchingFilters(agent, productGroupFilter) {
                var count = 0;
                agent.productGroups.forEach(function (product) {
                    productGroupFilter.forEach(function (filter) {
                        if (product.platformId === filter) {
                            count++;
                        }
                    });
                });
                return [count, agent];
            }
            function sortArrayDescending(array) {
                var sortedArray = __spreadArray([], array, true);
                sortedArray.sort();
                sortedArray.reverse();
                return sortedArray;
            }
            function filterAgentsByProductGroup(agents, productGroupFilter) {
                var sortedAgentWithAmounts = new Array();
                agents.forEach(function (agent) {
                    sortedAgentWithAmounts.push(countNumberOfMatchingFilters(agent, productGroupFilter));
                });
                sortedAgentWithAmounts = sortArrayDescending(sortedAgentWithAmounts);
                return getAgents(sortedAgentWithAmounts);
            }
            function filterAgentsByLastName(agents, lastName) {
                var withLastName = [];
                var withoutLastName = [];
                agents.forEach(function (agent) {
                    if (agent.lastName.toLowerCase().includes(lastName)) {
                        withLastName.push(agent);
                    }
                    else {
                        withoutLastName.push(agent);
                    }
                });
                return withLastName.concat(withoutLastName);
            }
            function filterAgentsByQuery(agents) {
                if (officeQuery.productGroups && officeQuery.productGroups.length !== 0) {
                    agents = filterAgentsByProductGroup(agents, officeQuery.productGroups);
                }
                if (officeQuery.agentWithLastName && officeQuery.agentWithLastName.length !== 0) {
                    agents = filterAgentsByLastName(agents, officeQuery.agentWithLastName.toLowerCase());
                }
                return readjustAgentsUrl(agents);
            }
            function readjustAgentsUrl(agents) {
                var rightUrl = window.location.protocol + '//' + window.location.hostname;
                $.each(agents, function (i, agent) {
                    if (typeof agent.url != 'undefined') {
                        var agentUrlParts = agent.url.replace('//', '').split('/');
                        if (agentUrlParts[0].indexOf('http:') || agentUrlParts[0].indexOf('https:')) {
                            var agentUrl = agentUrlParts[0].replace('https:', 'https://').replace('http:', 'http://');
                            agents[i].url = agent.url.replace(agentUrl, rightUrl);
                            agents[i].profilePageUrl = agent.profilePageUrl.replace(agentUrl, rightUrl);
                        }
                    }
                });
                return agents;
            }
            function renderOffices() {
                //Filter all offices that we already display (because we load offices without filters after the ones with filters duplicates can occur)
                officePage.offices = officePage.offices.filter(function (value) {
                    return !displayedOffices.includes(value.id);
                });
                //If we already buffered offices, put those to front of array because they come first in the sort order
                bufferedOffices.forEach(function (o) { return officePage.offices.unshift(o); });
                //We only want a maximum of PAGE_SIZE offices at a time -> if we have more, buffer them for next load
                while (officePage.offices.length > (PAGE_SIZE - (displayedOffices.length % PAGE_SIZE))) {
                    // @ts-ignore
                    bufferedOffices.push(officePage.offices.pop());
                }
                //Set some fields
                officePage.offices.forEach(function (office) {
                    displayedOffices.push(office.id);
                    var distance = office.distance.toFixed(0);
                    if (office.agents) {
                        office.agents = filterAgentsByQuery(office.agents);
                    }
                    office.formattedDistance = distance + String.fromCharCode(160) + "km";
                    office.place = GoogleMapsButton.place(office.street, office.zipCode, office.city);
                    office.pagelink = '/ort/' + slugify(office.displayName) + '.html';
                });
                //Return the rendered template
                return HypoportMustache.render($officeTemplate, officePage);
            }
            function slugify(str) {
                str = str.replace(/^\s+|\s+$/g, ''); // trim
                str = str.toLowerCase();
                str = str.replace(/\u00df/g, 'ss')
                    .replace(/\u00e4/g, 'ae')
                    .replace(/\u00f6/g, 'oe')
                    .replace(/\u00fc/g, 'ue')
                    .replace(/[^a-z0-9 -]/g, '')
                    .replace(/\s+/g, '-')
                    .replace(/-+/g, '-');
                return str;
            }
            if (officePage.transactionId == currentTransactionId) {
                //Append the newly rendered offices
                searchResultContainer.append(renderOffices());
                officeQuery.page = officePage.page;
                //If there are no offices in this page (e.g. because they were all filtered because they are already displayed)
                if (officePage.offices.length == 0) {
                    //If there are more pages we can load, go ahead and load those
                    if (officePage.page + 1 < officePage.numberOfPages) {
                        officeQuery.page++;
                        OfficeService.getOffices(officeQuery, currentTransactionId).then(handleOfficeResponse);
                        //If there are no more pages but we can try a less filtered request, do that
                    }
                    else if (loadUnfiltered()) {
                        OfficeService.getOffices(unfilteredOfficeQuery, currentTransactionId).then(handleOfficeResponse);
                        //If there is no way to get more offices, we are done
                    }
                    else {
                        searchResultContainer.append(renderOffices());
                        $(SEARCH_THROBBER_ID).hide();
                    }
                }
                else {
                    //We have loaded 10 offices since the last submit or "load more"-click
                    if (displayedOffices.length % PAGE_SIZE == 0) {
                        $(SEARCH_THROBBER_ID).hide();
                        if (officePage.page + 1 < officePage.numberOfPages || loadUnfiltered()) {
                            $loadMoreButton.show();
                        }
                        //We don't have a multiple of 10, so go and load more pages (if the request returns an empty response it is handled above)
                    }
                    else {
                        officeQuery.page++;
                        OfficeService.getOffices(officeQuery, currentTransactionId).then(handleOfficeResponse);
                    }
                }
            }
        }
        /**
         * Try to remove filters to load more offices
         * @return boolean: true if another page can be requested with the changed filters, false if there are already no filters
         */
        function loadUnfiltered() {
            //If we are already unfiltered, nothing more to do
            if (!consideringLastName && !consideringProductGroups) {
                $loadMoreButton.hide();
                $(SEARCH_THROBBER_ID).hide();
                return false;
            }
            else {
                unfilteredLastUsed = true;
                if (consideringLastName) {
                    consideringLastName = false;
                }
                return true;
            }
        }
        /**
         * Get offices with the given query parameters
         * @param queryLastName
         * @param queryProductGroupPlatformIds
         */
        function queryOffices(queryLastName, queryProductGroupPlatformIds) {
            $(SEARCH_THROBBER_ID).show();
            officeQuery = {
                latitude: currentLocation.latitude,
                longitude: currentLocation.longitude,
                page: 0,
                size: PAGE_SIZE,
            };
            unfilteredOfficeQuery = {
                latitude: currentLocation.latitude,
                longitude: currentLocation.longitude,
                page: 0,
                size: PAGE_SIZE,
            };
            unfilteredLastUsed = false;
            if (queryLastName) {
                officeQuery.agentWithLastName = queryLastName;
                consideringLastName = true;
            }
            if (queryProductGroupPlatformIds) {
                officeQuery.productGroups = queryProductGroupPlatformIds;
                consideringProductGroups = true;
            }
            OfficeService.getOffices(officeQuery, currentTransactionId).then(handleOfficeResponse).fail(function () {
                $(SEARCH_THROBBER_ID).hide();
                $loadMoreButton.hide();
            });
        }
        /**
         * Store search parameters in local store
         * @param queryZipCodeAndCity
         * @param queryLastName
         * @param queryProductGroupPlatformIds
         */
        function storeSearchParamsInLocalStorage(queryZipCodeAndCity, queryLastName, queryProductGroupPlatformIds) {
            var searchParamsAsJson = JSON.stringify([queryZipCodeAndCity, queryLastName, queryProductGroupPlatformIds]);
            localStorage.setItem(localStoragePath, searchParamsAsJson);
        }
        /**
         * Read search parameters from local store
         */
        function readSearchParamsFromLocalStorage() {
            return JSON.parse(localStorage.getItem(localStoragePath)) || false;
        }
        /**
         * Prefill the form based on stored search parameters
         */
        function prefillSearchForm() {
            var searchParamsInLocalStorage = readSearchParamsFromLocalStorage();
            var location = searchParamsInLocalStorage[0];
            var lastname = searchParamsInLocalStorage[1];
            var productGroups = searchParamsInLocalStorage[2];
            $officeSearchForm.find("input[name=location]").val(location);
            $officeSearchForm.find("input[name=nachname]").val(lastname);
            if (productGroups.length > 0) {
                if (productGroups.includes("BAUFINANZIERUNG")) {
                    $officeSearchForm.find("input[id=produktsparte_beratersuche_BAUFINANZIERUNG]").prop("checked", true);
                }
                if (productGroups.includes("VERSICHERUNG")) {
                    $officeSearchForm.find("input[id=produktsparte_beratersuche_VERSICHERUNG]").prop("checked", true);
                }
                if (productGroups.includes("RATENKREDIT")) {
                    $officeSearchForm.find("input[id=produktsparte_beratersuche_RATENKREDIT]").prop("checked", true);
                }
            }
        }
        /**
         * Load more offices
         * @param query
         */
        function loadMoreOfQuery(query) {
            query.page++;
            OfficeService.getOffices(query, currentTransactionId).then(handleOfficeResponse);
        }
        /**
         * Check the browser support of local storage an prefill the form
         */
        //Check browser support
        if (typeof (Storage) !== "undefined") {
            //Prefill out form if there are values in local store
            if (localStorage.getItem(localStoragePath) !== null) {
                prefillSearchForm();
            }
        }
        /**
         * When the form is submitted, update the queryParameters with the new values and send a request
         */
        $officeSearchForm.on("submit", function (event) {
            clearResults();
            var queryZipCodeAndCity = $officeSearchForm.find("input[name=location]").val().toString();
            var queryLastName = $officeSearchForm.find("input[name=nachname]").val().toString();
            var queryProductGroupPlatformIds = [];
            window.dispatchEvent(new CustomEvent("hypoport.drklein.gaTracking", {
                detail: {
                    event: "ConsultantSearch",
                    gaEventCategory: "Consultant Search",
                    gaEventAction: "Submit",
                    gaEventLabel: queryZipCodeAndCity + " | " + queryLastName,
                },
            }));
            $officeSearchForm
                .find("input[name=produktsparte]:checked")
                .each(function (index, element) {
                queryProductGroupPlatformIds.push($(element).val().toString());
            });
            if (queryZipCodeAndCity) {
                //if the location did not change, simply query new agents
                if (currentLocation && queryZipCodeAndCity === currentLocation.address) {
                    queryOffices(queryLastName, queryProductGroupPlatformIds);
                }
                else {
                    //if the location changed, get longitude and latitude from google, update current location and get new agents
                    GoogleMaps
                        .getGeolocation(queryZipCodeAndCity)
                        .then(function (latitude, longitude) {
                        currentLocation = {
                            latitude: latitude,
                            longitude: longitude,
                            address: queryZipCodeAndCity,
                        };
                        queryOffices(queryLastName, queryProductGroupPlatformIds);
                    });
                }
            }
            else {
                //if no location was entered, use the geoLocation for the query
                Geolocation
                    .getGeolocation()
                    .then(function (location) {
                    currentLocation = location;
                    $officeSearchForm.find("input[name=location]").val(location.address);
                    queryOffices(queryLastName, queryProductGroupPlatformIds);
                });
            }
            //store search parameters
            storeSearchParamsInLocalStorage(queryZipCodeAndCity, queryLastName, queryProductGroupPlatformIds);
            event.preventDefault();
        });
        $officeSearchForm.find(".beratersuche_produktsparte input").on("click", function () { return $officeSearchForm.trigger("submit"); });
        $loadMoreButton.on("click", function (event) {
            $(SEARCH_THROBBER_ID).show();
            $loadMoreButton.hide();
            if (unfilteredLastUsed) {
                loadMoreOfQuery(unfilteredOfficeQuery);
            }
            else {
                loadMoreOfQuery(officeQuery);
            }
            event.preventDefault();
        });
        /**
         * If a zipCode was passed as a parameter, use that as location
         */
        var plzQueryParameter = UrlParameters.getParameterByName("plz");
        if (plzQueryParameter !== undefined) {
            $officeSearchForm.find("input[name=location]").val(plzQueryParameter);
        }
        /**
         * If the correct location could not be determined, the user has the option here to allow his browser to share the location
         * with us
         */
        NichtIhreRegionHint.addCallback(function () {
            $officeSearchForm.find("input[name=location]").val("");
            $officeSearchForm.trigger("submit");
        });
        $beratersucheNichtIhreRegion.on("click", function () { return $beratersucheNichtIhreRegionHint.slideToggle(); });
        /**
         * Submit the form on load to get the initial batch of offices
         */
        $officeSearchForm.trigger("submit");
    });
});
